<i #secondaryIcon [style.background-color]="card.color"
   [style.opacity]="secondaryIcon.offsetWidth < 20 ? 0 : 1"
   style="font-weight: 300;font-optical-sizing: auto;"
   class="vr-ic_fluent_{{card.icon}}_24_regular iconContainer"></i>
<div style="display: flex; flex-direction: column; justify-content: end; flex: 3 1">
  <span style="font-size: 1rem;">{{ card.partitionName }} > {{ card.deviceName }} > {{ card.name }}</span>
  <div>
    <span
      style="font-size: 1.3rem; white-space: nowrap; font-weight: 600">{{ appService.getParsedMetricValue(card) }}</span>
    <span
      style="margin-left: 0.2ch; font-size: 18px; white-space: nowrap; font-weight: 300; text-shadow: rgba(0,0,0,.01) 0 0 1px;">{{ card.dataUnit }}</span>
  </div>
</div>
